import {makeAutoObservable} from "mobx";
import {product} from "./Product";

class Price {
  /**
   * Array of price objects.
   *
   * @param {Object[]} pricesData
   * @param {number} pricesData.id - Variant ID
   * @param {number} pricesData.selling_plan - Selling Plan Id. It can be null.
   * @param {number} pricesData.compareAtPrice - Compare At Price
   * @param {number} pricesData.price - Price
   * @param {number} pricesData.weight - Weight
   * @param {number} pricesData.volume - Volume
   * @param {number} pricesData.kg_price - Kg Price
   * @param {number} pricesData.l_price - L Price
   */
  productStore = {};
  pricesData = [];

  constructor(product) {
    makeAutoObservable(this);
    this.productStore = product;
  }

  setPricesData(pricesData) {
    this.pricesData = pricesData;
  }

  get currentPrice() {
    return (
      this.pricesData.find(
        priceData =>
          priceData.id === this.productStore.variantId &&
          priceData.quantity === this.productStore.quantity &&
          priceData.selling_plan === this.productStore.sellingPlanId,
      ) ??
      this.pricesData.find(
        priceData =>
          priceData.id === this.productStore.variantId &&
          priceData.selling_plan === this.productStore.sellingPlanId,
      ) ??
      this.pricesData.find(
        priceData =>
          priceData.id === this.productStore.variantId &&
          priceData.quantity === this.productStore.quantity,
      ) ??
      this.pricesData.find(
        priceData => priceData.id === this.productStore.variantId,
      ) ??
      this.pricesData[0]
    );
  }

  get pricesQtd1() {
    const subscriptionPrice =
      this.pricesData.find(
        priceData =>
          priceData.id === this.productStore.variantId &&
          priceData.quantity === 1 &&
          priceData.selling_plan,
      ) ??
      this.pricesData.find(
        priceData =>
          priceData.id === this.productStore.variantId &&
          priceData.selling_plan,
      ) ??
      this.pricesData[0];

    const otpPrice =
      this.pricesData.find(
        priceData =>
          priceData.id === this.productStore.variantId &&
          priceData.quantity === this.productStore.quantity &&
          !priceData.selling_plan,
      ) ??
      this.pricesData.find(
        priceData =>
          priceData.id === this.productStore.variantId &&
          !priceData.selling_plan,
      ) ??
      this.pricesData[0];

    return {subscriptionPrice, otpPrice};
  }

  getPrice(id, selling_plan, quantity) {
    return (
      this.pricesData.find(
        priceData =>
          priceData.id === id &&
          priceData.quantity === quantity &&
          priceData.selling_plan === selling_plan,
      ) ??
      this.pricesData.find(
        priceData =>
          priceData.id === id && priceData.selling_plan === selling_plan,
      ) ??
      this.pricesData.find(
        priceData => priceData.id === id && priceData.quantity === quantity,
      ) ??
      this.pricesData[0]
    );
  }
}

export const price = new Price(product);
